import { SyntaxHighlighter } from "@githits/replay-shared";
import oneDark from "react-syntax-highlighter/dist/esm/styles/prism/one-dark";

// Strip background from all oneDark token styles so lines don't get a visible bg
const theme: Record<string, React.CSSProperties> = {};
for (const [key, value] of Object.entries(oneDark)) {
  const style = value as React.CSSProperties;
  if (style.background || style.backgroundColor) {
    const { background, backgroundColor, ...rest } = style;
    theme[key] = rest;
  } else {
    theme[key] = style;
  }
}

interface CodeBlockProps {
  code: string;
  language: string;
  sources: string[];
}

export default function CodeBlock({ code, language, sources }: CodeBlockProps) {
  return (
    <div
      className="ghw-flex ghw-flex-col ghw-flex-1 ghw-min-h-0"
      style={{
        background: "#13161a",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      {/* Sources — fixed, doesn't scroll */}
      {sources.length > 0 && (
        <div
          className="ghw-shrink-0"
          style={{
            padding: "16px 16px 12px",
            fontSize: 12,
            lineHeight: "16px",
            color: "#abb2bf",
          }}
        >
          <div
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 600,
              fontSize: 10,
              lineHeight: "12px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              color: "#72767f",
              marginBottom: 8,
            }}
          >
            {sources.length} Sources
          </div>
          {sources.map((repo, i) => (
            <span key={repo}>
              {i > 0 && " · "}
              <a
                href={`https://github.com/${repo}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-source-link"
                style={{ color: "inherit", textDecoration: "none" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.textDecoration = "underline";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "inherit";
                  e.currentTarget.style.textDecoration = "none";
                }}
              >
                {repo}
              </a>
            </span>
          ))}
        </div>
      )}

      {/* Code — scrollable */}
      <div
        className="ghw-overflow-auto ghw-flex-1 ghw-min-h-0 replay-dark-scrollbar"
        style={{ padding: 16 }}
      >
        <SyntaxHighlighter
          language={language === "text" ? undefined : language}
          style={theme}
          customStyle={{
            margin: 0,
            padding: 0,
            background: "transparent",
            fontFamily: "'Consolas', monospace",
            fontSize: 14,
            lineHeight: "22px",
            textShadow: "0 0.0625rem 0 rgba(0,0,0,0.3)",
          }}
          wrapLongLines
        >
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  );
}
